<h2 mat-dialog-title>{{ inputData.title }}</h2>
<mat-dialog-content [formGroup]="activeForm">

    <mat-form-field appearance="outline">
      <mat-label>Nom d'utilisateur</mat-label>
      <input
        matInput
        type="text"
        formControlName="username"
        placeholder="Entrez votre username">
      @if (activeForm.get('username')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
       @if (activeForm.get('username')?.hasError('minlength')) {<mat-error>6 caracteres au minimum</mat-error>}
    </mat-form-field>

    <div class="" formGroupName="passwordGroup">
      <mat-form-field appearance="outline">
        <mat-label>Mot de passe</mat-label>
        <input
          matInput
          type="password"
          #password
          formControlName="password"
          placeholder="Entrez votre mot de passe">
        @if (activeForm.get('passwordGroup')?.get('password')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        @if (activeForm.get('passwordGroup')?.get('password')?.hasError('minlength')) {<mat-error>6 caracteres au minimum</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Confirmer le mot de passe</mat-label>
        <input
          matInput
          type="password"
          #confirmPassword
          formControlName="confirmPassword"
          placeholder="Confirmer le mot de passe">
        @if (activeForm.get('passwordGroup')?.get('confirmPassword')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        @if (activeForm.get('passwordGroup')?.get('confirmPassword')?.hasError('minlength')) {<mat-error>6 caracteres au minimum</mat-error>}
        @if (activeForm.get('passwordGroup')?.hasError('confirmPassword') &&
        confirmPassword.value !='' &&
        password.value != '' &&
         activeForm.get('passwordGroup')?.get('confirmPassword')?.touched) {<mat-error>Les 2 champs ne correspondent pas</mat-error>}
      </mat-form-field>
    </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="bg-mat-green" [disabled]="activeForm.invalid || loading()" (click)="onSave()">
    Enregistrer
  </button>
  @if (loading()) {
    <mat-spinner diameter="30"></mat-spinner>
  }

</mat-dialog-actions>
